var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('td',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }